(function ($) {
    // Return redirect
    const url_return = new URLSearchParams(location.search).get('return_to');
    if (url_return) {
        $('form[action*="/account/login"]').append(`<input type="hidden" name="return_to" value="${url_return}">`);
    }

    // Show/hide recover form based on hash
    function toggleRecoverForm() {
        const $recoverSection = $('#recover');
        const $loginSection = $('#login');
        
        if (window.location.hash === '#recover') {
            $recoverSection.show();
            $loginSection.hide();
        } else {
            $recoverSection.hide();
            $loginSection.show();
        }
    }

    // Handle click on "forgot password" link
    $(document).on('click', 'a[href*="#recover"]', function(e) {
        e.preventDefault();
        window.location.hash = '#recover';
        toggleRecoverForm();
    });

    // Handle click on "cancel" link in recover form
    $(document).on('click', 'a[href="/account/login"]', function(e) {
        if ($(this).closest('#recover').length) {
            e.preventDefault();
            window.location.hash = '';
            toggleRecoverForm();
        }
    });

    // Create customerAccessToken when login form is submitted
    $(document).on('submit', 'form[action*="/account/login"]', async function(e) {
        const $form = $(this);
        const email = $form.find('input[name="customer[email]"]').val();
        const password = $form.find('input[name="customer[password]"]').val();
        
        // Only create token if email and password are provided
        if (email && password && window.CustomerAuth && window.CustomerAuth.create) {
            // Check if we've already processed this form (avoid infinite loop)
            if ($form.data('token-processing')) {
                return; // Let form submit normally
            }
            
            // Prevent form submission temporarily
            e.preventDefault();
            e.stopPropagation();
            
            // Mark form as processing
            $form.data('token-processing', true);
            
            try {
                // Create customerAccessToken before form submits
                const tokenResult = await window.CustomerAuth.create(email, password);
                
                if (tokenResult && tokenResult.customerAccessToken && tokenResult.customerAccessToken.accessToken) {
                    const accessToken = tokenResult.customerAccessToken.accessToken;
                    const expiresAt = tokenResult.customerAccessToken.expiresAt;
                    // Save token to localStorage
                    window.CustomerAuth.saveToStorage(accessToken, expiresAt);
                    console.log('Customer access token created and saved');
                } else if (tokenResult && tokenResult.customerUserErrors && tokenResult.customerUserErrors.length > 0) {
                    // If token creation fails, log error but still allow form submission
                    // (let Shopify handle authentication - maybe password is wrong)
                    console.warn('Token creation failed:', tokenResult.customerUserErrors);
                }
            } catch (err) {
                // If token creation fails, log error but still allow form submission
                // (let Shopify handle authentication)
                console.error('Token creation error:', err);
            }
            
            // Submit form after token creation attempt (whether success or fail)
            // Create a new form submission by triggering native submit
            const formElement = $form[0];
            const submitButton = document.createElement('input');
            submitButton.type = 'submit';
            submitButton.style.display = 'none';
            formElement.appendChild(submitButton);
            submitButton.click();
        }
        // If no CustomerAuth available or no email/password, let form submit normally
    });

    // ==================================================
    // Recover Password Form Handler
    // ==================================================
    $(document).on('submit', 'form[action*="/account/recover"]', function(e) {
        const $form = $(this);
        const $emailInput = $form.find('input[name="email"]');
        const email = ($emailInput.val() || '').trim();
        
        // Helper: Show error message (above form, after title)
        function showError(message) {
            // Remove existing messages
            $('#recover .txt_error, #recover .txt_success').remove();
            
            // Show error message above form (after h1 title)
            const $recoverSection = $('#recover');
            const $title = $recoverSection.find('.tlt_section');
            if ($title.length) {
                $title.after(`<p class="txt_error">${message}</p>`);
            } else {
                // Fallback: before form_wrap
                const $errorContainer = $form.find('.form_wrap').length 
                    ? $form.find('.form_wrap') 
                    : $form.find('#form_recover');
                $errorContainer.before(`<p class="txt_error">${message}</p>`);
            }
            $emailInput.addClass('error').focus();
        }
        
        // 1. Validate email is not empty
        if (!email) {
            e.preventDefault();
            e.stopPropagation();
            showError('メールアドレスを入力してください。');
            return false;
        }
        
        // 2. Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            e.preventDefault();
            e.stopPropagation();
            showError('メールアドレスの形式が正しくありません。');
            return false;
        }
        
        // 3. Clear previous errors
        $form.find('.txt_error').remove();
        $emailInput.removeClass('error');
        
        // 4. Allow form to submit normally (Shopify will handle it)
        // Form will reload and show success/error message from template
    });

    // Initial check
    $(document).ready(function() {
        const $recoverSection = $('#recover');
        const hasSuccessMessage = $recoverSection.find('.txt_success').length > 0;
        const hasErrorMessage = $recoverSection.find('.txt_error').length > 0;
        
        // Check for "too many requests" error and replace with Japanese message
        if (hasErrorMessage) {
            const $errorMsg = $recoverSection.find('.txt_error');
            const errorText = $errorMsg.text().toLowerCase();
            
            // Check for "too many requests" or "rate limit" errors
            if (errorText.includes('too many') || 
                errorText.includes('rate limit') || 
                errorText.includes('many requests') ||
                errorText.includes('リクエストが多すぎます') ||
                errorText.includes('リクエストが多すぎ')) {
                // Replace with Japanese message
                const $title = $recoverSection.find('.tlt_section');
                $errorMsg.remove();
                if ($title.length) {
                    $title.after('<p class="txt_error">リクエストが多すぎます。しばらく時間をおいてから再度お試しください。</p>');
                } else {
                    $recoverSection.find('.form_wrap, #form_recover').first().before('<p class="txt_error">リクエストが多すぎます。しばらく時間をおいてから再度お試しください。</p>');
                }
            }
        }
        
        // Show recover section only if there's success/error message from Shopify
        if (hasSuccessMessage || hasErrorMessage) {
            // Show recover section and hide login section
            $recoverSection.show();
            $('#login').hide();
            // Set hash to maintain state
            window.location.hash = '#recover';
        } else {
            // Normal toggle based on hash
            toggleRecoverForm();
        }
        
        // Listen for hash changes
        $(window).on('hashchange', function() {
            toggleRecoverForm();
        });
    });
})(jQuery);